import ajax from '../http/ajax'

export const getCouponListByService = data => {
    return ajax.get('getCouponListByService', data)
}

export const getCouponListByPackage = data => {
    return ajax.get('getCouponListByPackage', data)
}
